import { User } from '../types';

export function hasVerifiedEmail(user: User | null | undefined): boolean {
  return !!user?.isEmailVerified;
}

export function canUsePlatform(isAuthenticated: boolean, user: User | null | undefined): boolean {
  return isAuthenticated && hasVerifiedEmail(user);
}
